import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Table } from '../../../../common/table'
import { AUTO_MAX_HEIGHT_TABLE } from '../../constants'
import { getSchema } from '../helper'
import classes from '../index.module.scss'
import { selectSegmentIndustry } from '../store/slice'
import withLoadingFeedBack from '../withLoadingFeedback'
import { TBodyCustom } from './TBodyCustom'

const TableComponent = ({ isCreditScore, treeData }) => {
  const rawData = useSelector(selectSegmentIndustry)

  const schema = getSchema(isCreditScore)
  const ids = rawData.length ? treeData.map((item) => item.id) : []

  return (
    <div className={classes.container}>
      <Element className="flex1 minH0">
        <Table
          ids={ids}
          schema={schema}
          autoHeightMax={AUTO_MAX_HEIGHT_TABLE}
          renderTBody={() => {
            return <TBodyCustom ids={ids} schema={schema} />
          }}
        />
      </Element>
    </div>
  )
}

export default withLoadingFeedBack(TableComponent)
